module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-236.3fab9b57.svg";